import { Pie } from "react-chartjs-2";

const RepairTimePieChart = ({ data }: any) => {
  // Prepare data for the pie chart
  const chartData = {
    labels: data?.map((machine: any) => machine.machine_code), // Machine codes
    datasets: [
      {
        label: "Temps total de réparation (minutes)",
        data: data?.map(
          (machine: any) => (parseFloat(machine.total_repairing_time) || 0) * 60
        ), // Convert repair time to minutes
        backgroundColor: [
          "#FF6384",
          "#36A2EB",
          "#FFCE56",
          "#FF5733",
          "#4CAF50",
          "#FFB300",
          "#008CBA",
          "#F44336",
          "#673AB7",
          "#795548",
          "#9E9E9E",
          "#607D8B",
        ],
        hoverOffset: 4,
      },
    ],
  };

  return (
    <div>
      <h2>Temps total de réparation par machine</h2>
      <Pie data={chartData} />
    </div>
  );
};
export default RepairTimePieChart;
